<script lang="ts">
	import type { ImageProps } from '@app/components/cms/types';
	import Avatar from '$lib/elements/Avatar.svelte';
	import { getInitials, getShortName } from '@app/utils/user';
	import { getOptimizedCmsImageUrl } from '@app/utils/cms.js';
	import { formatDateWithLocale } from '$lib/utils/date.js';

	export let props: {
		text: string;
		avatar?: ImageProps;
		firstName: string;
		lastName: string;
		date: string;
	};

	export let classNames: string;
</script>

<div class="bg-white p-5 flex flex-col gap-5 rounded-lg {classNames}">
	<div class="flex-1">"{props.text}"</div>
	<div class="flex gap-3 items-center">
		<div>
			<Avatar
				imageUrl={props.avatar.filename
					? getOptimizedCmsImageUrl(props.avatar.filename, '64x64')
					: undefined}
				initials={getInitials(props.firstName, props?.commonName ?? props?.lastName)}
				size="big"
				classNames="!w-[64px] !h-[64px]"
			/>
		</div>
		<div class="">
			<div class="font-semibold">
				{getShortName(props.firstName, props.lastName)}
			</div>
			{#if props.date !== ''}
				<div class="text-grey-dark">
					le {formatDateWithLocale(props.date, 'dd MMMM yyyy')}
				</div>
			{/if}
		</div>
	</div>
</div>
